import regeneratorRuntime from 'regenerator-runtime';
// Shared Libs
import '../shared/js/l10n';
import '../shared/js/async_storage';
// Libs
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Router, { route } from 'preact-router';
import Account from 'account';
import { utils } from 'utils';
import { setThemeColor, hideFakeSSR } from './helper/user-interface-helper';
import AppStore from 'app-store';
import { mozActivityManager } from 'mozactivity-manager';
import { deviceUtils } from './device-utils';
import KaistoreHawkHelper from 'kaistore-hawk-helper/lib';
import KaistoreAppListHelper from 'kaistore-applist-helper/lib';
import KaistoreCategoriesHelper from 'kaistore-categories-helper/lib';
import { receiveMessage } from './helper/message-receiver';
import { MessageListener, MessageSender } from 'web-message-helper';
import {
  RequestExitCommand,
  RequestInstalledAppsCommand,
  ShowToastCommand
} from 'kaistore-post-messenger/src/commands';
import { Toast } from 'kaistore-post-messenger/src/models';
import PaymentHelper from '../src/helper/payment-helper';
import UserInterfaceHelper from './helper/user-interface-helper';
import { tokenType } from 'kaistore-post-messenger/lib/constants';
import { APP_ORIGIN, PATH } from './constant';
import 'lib/debug-error.js';

// Component
import ReactSoftKey from 'react-soft-key';
import Loading from 'Loading';
import Page from 'Page';
import Appspanel from 'Appspanel';
import Settingsview from 'Settingsview';
import ReactDialog from 'react-dialog';

// CSS
import 'react-soft-key/assets/index.scss';
import '../scss/app.scss';
import '../scss/largetext.scss';

import '../shared/elements/gaia-theme/gaia-theme.css';
import '../shared/elements/gaia_tabs/style.css';
import '../shared/elements/gaia-theme/gaia-font.css';
import '../shared/elements/gaia-icons/gaia-icons.css';

const KEY_SERVER_TIME_OFFSET = 'hawk-request-server-time-offset';

class App extends Component {
  constructor() {
    super();
    utils.remoteStartTime = new Date().getTime();
    performance.mark('REMOTE_STORE');
    performance.mark('REMOTE_PAGE_RENDERING_START');
    console.warn('start to render remote page at ', utils.remoteStartTime);
    this.entryURL = null;
    this.currentRoute = null;

    MessageSender.remoteReady = true;
    this.dialogQueue = [];
    // get default state.
    this.state = this.getInitialState();
    // save token information.
    this.tokenInfo = {
      assertion: null,
      type: tokenType.RESTRICTED,
      status: false
    };
    this.refs = {};
    // init KaiOS account
    Account.init();
    this.startMessengers();

    performance.mark('REQUEST_DEVICE_START');
    deviceUtils.requestInfo().then(() => {
      performance.mark('REQUEST_DEVICE_END');
      this.boot();
    });
  }

  getInitialState() {
    const initialState = {
      noAvailableAPP: false,
      dialog: false,
      dialogOptions: {},
      plusInfo: {
        version: '2.4' // default
      },
      readyToRoute: false, // true when all prerequisites have finished
      isViewingSetting: false
    };
    return initialState;
  }

  resetState() {
    this.prepareDownload = AppStore.preparedDownloadApp;
    AppStore.init();
    this.setState(this.getInitialState());
  }

  boot(event) {
    const isReboot = !(typeof event === 'undefined');
    if (isReboot) {
      // resetState
      this.resetState();
      route(PATH.LOADING.URL());
      // reset appStore.
      AppStore.resetStore();
      deviceUtils.requestInfo().then(() => {
        this.startRemoteServices();
      });
    } else {
      this.initPreparation();
    }
  }

  initPreparation() {
    // Listen relative events
    this.startEventListener();

    // Get the time offset from indexedDB if it exists
    asyncStorage.getItem(KEY_SERVER_TIME_OFFSET, result => {
      window.serverTimeOffset = result;
    });

    // hide the fake SSR and switch to the real loading page.
    hideFakeSSR();
    // prepare price
    this.paymentHelper = new PaymentHelper();
    this.paymentHelper
      .getProfile()
      .then(result => {
        window.unitPrice = result.unitPrice;
      })
      .catch(() => {
        window.unitPrice = null;
      })
      .then(() => {
        this.fetchDataAndGenerateUI();
      });
  }

  fetchDataAndGenerateUI = () => {
    this.resetState();
    // show loading panel.
    route(PATH.LOADING.URL());
    // show no network UI and early return here.
    if (!navigator.onLine) {
      // reset state to make sure UI works correctly.
      this.setMsg('no-internet');
      console.error('no network');
      return;
    }
    // Start to request things from server,
    // such as token, app-list, categories and service worker.
    this.startRemoteServices();
  };

  startRemoteServices() {
    // Pass device info and IMEI to dynamicCategory.
    KaistoreCategoriesHelper.init({
      deviceInfo: window.deviceInfos,
      imei: window.IMEI,
      commsInfo: deviceUtils.information.connection,
      serverTimeOffset: window.serverTimeOffset,
      useCustomConnectionType: true
    });
    performance.mark('REQUEST_TOKEN_START');
    Account.requestToken().then(detail => {
      const { token, type } = detail;
      this.tokenInfo = {
        assertion: token,
        type: type,
        status: true
      };
      KaistoreHawkHelper.setToken(token.kid, token.macKey);
      KaistoreHawkHelper.setCustomConnectionType(
        deviceUtils.information.connection.type
      );
      performance.mark('REQUEST_TOKEN_END');
      this.fetchAppsAndCategories();
    });
  }

  stop() {
    this.stopEventListener();
  }

  startMessengers() {
    MessageSender.validMessageOrigins = [APP_ORIGIN];
    MessageSender.targetOrigin = APP_ORIGIN;
    MessageSender.start();
    MessageListener.start(receiveMessage);
  }

  startEventListener() {
    window.addEventListener('keydown', this.keydownHandler);
    window.addEventListener('online', this.fetchDataAndGenerateUI);
    window.addEventListener('offline', this.fetchDataAndGenerateUI);
    window.addEventListener('account:login', this.fetchDataAndGenerateUI);
    window.addEventListener('account:logout', this.fetchDataAndGenerateUI);
    window.addEventListener('reboot-needed', this.boot);

    window.addEventListener(
      'hawkrequester:offsetchange',
      this.handleHawkOffsetChange
    );

    UserInterfaceHelper.startListeners();
  }

  keydownHandler = event => {
    const { key } = event;

    switch (key) {
      case 'BrowserBack':
      case 'Backspace':
      case 'Escape':
        event.preventDefault();
        MessageSender.send(new RequestExitCommand());
        break;
      default:
        break;
    }
  };

  showNoPriceDialog() {
    const paymentHelper = new PaymentHelper();
    /**
     * If KaiPay version has been v2.3.1+, it is able to get price. If
     * not, it means KaiPay has been updated but not reloaded yet. So we
     * popup a dialog and inform users to restart the device.
     **/
    const kaipayVersion = paymentHelper.getKaipayVersion();
    const isNoProvider = paymentHelper.noProvider;
    const canGetPrice = paymentHelper.isSupportPrice(kaipayVersion);
    const noPriceDialogOptions = {
      header: 'no-price-header',
      type: 'alert',
      ok: 'ok',
      content: 'no-price-msg',
      onOk: () => {
        this.hideDialog(() => {
          isNoProvider && canGetPrice && this.showRestartDialog();
        });
      }
    };
    this.showDialog(noPriceDialogOptions);
  }

  showRestartDialog = () => {
    const restartDialogOptions = {
      header: 'no-price-header',
      type: 'alert',
      ok: 'ok',
      content: 'restart-phone-msg',
      onOk: this.hideDialog
    };
    this.showDialog(restartDialogOptions);
  };

  fetchAppsAndCategories() {
    // fetch latest app list
    performance.mark('FETCH_APPS_CAT_START');
    var assertion = this.tokenInfo.assertion;
    if (assertion) {
      const applistHelper = new KaistoreAppListHelper({
        deviceInfos: window.deviceInfos,
        simInfo: deviceUtils.information.connection,
        IMEI: window.IMEI,
        serverTimeOffset: window.serverTimeOffset,
        useCustomConnectionType: true
      });
      const isPaymentAvailable = window.unitPrice !== null;
      Promise.all([
        applistHelper.fetchAppList(isPaymentAvailable),
        KaistoreCategoriesHelper.getCategories()
      ])
        .then(result => {
          performance.mark('FETCH_APPS_CAT_END');
          const applistResult = result[0];
          const categoriesResult = result[1];
          AppStore.initRemoteApps(applistResult.apps);
          AppStore.hasPaidApp = applistResult.hasPaidApp;
          AppStore.categories = categoriesResult;
          this.prepareApps();
        })
        .catch(error => {
          this.serverError(error);
        });
    } else {
      console.error('No restricted token for fetching app list.');
    }
  }

  setMsg(messageL10nId, messageL10nArgs = {}) {
    if (document.visibilityState === 'hidden') {
      //Avoid to show toast when app is in background.
      return;
    }
    const command = new ShowToastCommand({
      detail: new Toast({
        messageL10nId: messageL10nId,
        messageL10nArgs: messageL10nArgs
      })
    });
    MessageSender.send(command);
  }

  redirectAppPage(manifestURL) {
    let activeApp = null;

    if (manifestURL) {
      activeApp = AppStore.findAppByManifest(manifestURL);
      if (activeApp) {
        route(PATH.PAGE.URL({ id: activeApp.id, autoDownload: true }));
      } else {
        this.handleAppNotFound();
      }
    }
  }

  prepareApps() {
    // In order to reduce render times, so fetch setting here.
    let isSupportedSettingsPanel = window.deviceInfos.get(
      'apps.serviceCenter.settingsEnabled'
    );
    performance.mark('REQUEST_INSTALLED_START');
    MessageSender.send(new RequestInstalledAppsCommand(), (success, detail) => {
      if (success) {
        const installedApps = detail;
        AppStore.syncInstalledApps(installedApps);
        AppStore.syncBookmarks().then(result => {
          deviceUtils.featureset = {
            bookmarkDBSupported: result.bookmarkDBSupported,
            settingsPanelSupported: isSupportedSettingsPanel
          };
          AppStore.syncPurchasedApps();

          this.requestLaunchList();
          // add eventListener after app list is ready
          // to avoid app is not found
          window.addEventListener('task-queue-updated', () => {
            let mozActivityTask = mozActivityManager.task;
            if (mozActivityTask) {
              this.handleActivityTask(mozActivityTask);
            }
          });
        });
        performance.mark('REQUEST_INSTALLED_END');
      }
    });
  }

  handleHawkOffsetChange = event => {
    let offset = event.detail.current;
    window.serverTimeOffset = offset;
    asyncStorage.setItem(KEY_SERVER_TIME_OFFSET, offset);
  };

  handleActivityTask(task) {
    let activeApp;
    const activityType = task.data.type;
    const adId = task.data.adId ? task.data.adId : null;
    let autoDownload = false;
    let disposition = 'window';

    // Support finding app via manifestURL and name;
    if (activityType === 'name') {
      const targetName = task.data.name;
      activeApp = AppStore.findAppByName(targetName);
    } else if (activityType === 'url') {
      const activeManifestURL = task.data.url;
      activeApp = AppStore.findAppByManifest(activeManifestURL);
    } else if (activityType === 'push-app') {
      const pushAppManifestURL = task.data.url;
      activeApp = AppStore.findAppByManifest(pushAppManifestURL);
      autoDownload = true;
    }

    switch (task.name) {
      case 'inline-open-page':
      case 'inline-open-by-name':
        disposition = 'inline';
        break;
      default:
        break;
    }

    if (activeApp) {
      route(
        PATH.PAGE.URL({
          id: activeApp.id,
          adId: adId,
          autoDownload: autoDownload,
          disposition: disposition
        })
      );
    } else {
      this.handleAppNotFound();
    }
  }

  handleAppNotFound() {
    // Launch app list first and then launch alert to notice user
    // can't find app.
    this.showNotFoundDialog();
  }

  showNotFoundDialog = () => {
    const notFoundDialogOptions = {
      header: 'not-found-header',
      type: 'alert',
      ok: 'ok',
      content: 'not-found-msg',
      onOk: this.hideDialog
    };
    this.showDialog(notFoundDialogOptions);
  };

  serverError(error) {
    var msg = error.errorMsgId;
    if (msg) {
      if (msg === 'no-app-available') {
        this.setState({ noAvailableAPP: true });
      } else {
        this.setMsg(msg);
      }
    }
  }

  stopEventListener() {
    //TODO
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.dialog !== this.state.dialog) {
      if (this.state.dialog) {
        this.onDialogInShowState();
      } else {
        this.onDialogInHideState();
      }
    }

    if (prevState.readyToRoute === false && this.state.readyToRoute === true) {
      if (this.prepareDownload) {
        this.redirectAppPage(this.prepareDownload);
      } else {
        route(this.entryURL);
        if (AppStore.kaipayUpdated) {
          this.showRestartDialog();
        } else if (window.unitPrice === null && AppStore.hasPaidApp) {
          this.showNoPriceDialog();
        }
      }
    }

    if (prevState.isViewingSetting !== this.state.isViewingSetting) {
      setThemeColor(this.state.isViewingSetting);
    }
  }

  requestLaunchList() {
    this.setState({ readyToRoute: true });
  }

  showDialog(options) {
    if (
      this.state.dialog === true ||
      this.currentRoute === PATH.LOADING.URL()
    ) {
      this.dialogQueue.push(options);
    } else {
      this.setState({
        dialog: true,
        dialogOptions: options
      });
    }
  }

  hideDialog = callback => {
    this.setState(
      {
        dialog: false,
        dialogOptions: {}
      },
      () => {
        if (callback) {
          callback();
        }
      }
    );
  };

  showNextDialog() {
    const nextDialog = this.dialogQueue.shift();
    if (nextDialog) {
      this.showDialog(nextDialog);
      return true;
    } else {
      return false;
    }
  }

  ensureDialogDisplay = () => {
    this.showNextDialog();
  };

  restActivity = () => {
    this.setState({
      activity: {
        disposition: 'window', // inline or window, default window
        donwloadType: 'maunal' // maunal or auto, default is maunal
      }
    });
  };

  onDialogInShowState() {
    const lastActive = document.activeElement;

    this.refs.dialog.show();
    this.refs.dialog.on('closed', () => {
      if (this.state.dialog) {
        // close by endKey
        this.hideDialog();
      }
      if (this.showNextDialog() === false) {
        lastActive.focus();
      }
    });
  }

  onDialogInHideState() {
    this.refs.dialog.hide();
  }

  onRouteChange = event => {
    if (this.entryURL === null) {
      this.entryURL = event.url;
    }
    this.currentRoute = event.url;

    this.setState({ isViewingSetting: event.url === PATH.SETTING.MATCH });
  };

  render() {
    return (
      <div
        className={
          'App ' +
          (this.state.isViewingSetting ? 'settings ' : 'bright ') +
          (navigator.largeTextEnabled ? 'large-text' : ' ')
        }
        id="app"
        tabIndex="-1"
      >
        <Router onChange={this.onRouteChange}>
          <Loading
            path={PATH.LOADING.MATCH}
            noAvailableAPP={this.state.noAvailableAPP}
          />
          {this.state.readyToRoute && (
            <Appspanel
              path={PATH.APPS.MATCH}
              ensureDialogDisplay={this.ensureDialogDisplay}
              default
            />
          )}
          <Settingsview path={PATH.SETTING.MATCH} />
          {this.state.readyToRoute && (
            <Page
              path={PATH.PAGE.MATCH}
              onAppNotFound={this.showNotFoundDialog}
            />
          )}
        </Router>
        <div
          className={'soft-key-wrapper ' + (this.state.dialog ? 'default' : '')}
        >
          <ReactSoftKey />
        </div>
        <div id="main-dialog" className={this.state.dialog ? '' : 'hidden'}>
          <ReactDialog
            ref={dialog => {
              this.refs['dialog'] = dialog;
            }}
            {...this.state.dialogOptions}
          />
        </div>
      </div>
    );
  }
}

navigator.mozL10n.once(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});



/** WEBPACK FOOTER **
 ** ./src/app.js
 **/